export default {
	introSectTitleHtml: `Создаём эффективные <br>продукты для людей`,
	introSectList: {
		str1: `Разрабатываем сайты и приложения`,
		str2: `Создаём дизайн, который отражает суть продукта`,
		str3: `Выстраиваем маркетинг <br class="d-sm-none">по 9 рекламным каналам`,
		str3TooltipTitle: `Выстраиваем маркетинг <br>по 9 рекламным каналам:`,
		str3TooltipInner: `
      <ol>
        <li>Реклама в поисковиках (Яндекс и Гугл)</li>
        <li>Продвижение в соцсетях (Фб, ВК, Инст)</li>
        <li>СЕО (блог, СМИ, Оптимизация сайта)</li>
        <li>Реклама в YouTube</li>
      </ol>
    `,
	},
	introSectLink: 'Перейти на сайт',

	portfolioSectTitleHtml: `<b>Реализованные проекты</b> <br class="d-none d-sm-block">лучше расскажут о нас`,
	viewPortfolio: 'Смотреть портфолио',
}
